import React, { ReactNodeArray } from 'react';
import { FilterFooter } from 'modules/filters/components/FilterFooter';
import { connect } from 'react-redux';
import { IStore } from 'reducers/index';
import { SORT_ORDER } from 'reducers/filters/models';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import {
    applyFiltersAction,
    clearFilters,
    setEmptyFilters,
    setFilter
} from 'actions/filters';
import { HandleError } from 'components/handle-error';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import queryString from 'query-string';
import { parseURLParamForFilters, hasFilterValues } from 'utilities/util';
import moment from 'moment';

interface IFiltersState {
    isExpanded: boolean;
    onApplyClickReq: boolean
}

interface IFilterOwnProps {
    filters: ReactNodeArray;
    error?: boolean;
    errorMessage?: string;
    resetPaging?: (pageNumber: any, pageSize: any) => void;
    watchChanges?: (data: any) => void;
    resetErrors?: () => void;
    disableSubmit?: boolean;
    fetchFunction: (pageNumber: any, pageSize: any) => void;
    buttons?: React.ReactChildren | React.ReactChild | React.ReactNodeArray;
    withoutFilters?: boolean;
    withoutPagination?: boolean;
    tableNameKey: string;
    defaultValue?: any;
    triggerClear?: boolean;
    triggerFilter?: any
    genericFilter?: string;
    requireFilters?: boolean;
    // values pre-filled when the tab is first opened (without URL filters) and restored on Clear
    defaultFilters?: () => { [name: string]: any };
}

interface IMapStateToProps {
    sort: {
        order: SORT_ORDER;
        column: string;
    }
    pageSize: number;
    totalCount: number;
    pageNumber: number;
    currentFilters: any;
    appliedFilters: any;
}

interface IDispatch {
    setEmptyFilters: (filters: ReactNodeArray) => void;
    setFilter: (name: string, value: string | boolean | any[] | number) => void;
    applyFilters: () => void;
    clearFilters: () => void;
}

interface IFilterProps extends RouteComponentProps, IDispatch, IMapStateToProps, IFilterOwnProps {
}
export class _Filters extends React.Component<IFilterProps, IFiltersState> {
    public static origin = '';
    public state: IFiltersState = {
        isExpanded: false,
        onApplyClickReq: false,
    };
    public myDom: any = React.createRef();
    public context: any;
    public componentWillUnmount(){
        if(this.myDom.current){
            this.myDom.current.removeEventListener('keydown', this.listenToKeys)
        }
    }
    public componentDidMount() {
        if(this.myDom.current){
            this.myDom.current.addEventListener('keydown', this.listenToKeys);
        }
        const isNewOrigin = _Filters.origin !== this.props.tableNameKey;
        if (isNewOrigin) {
            this.props.setEmptyFilters(this.props.filters);
            this.props.clearFilters();
        }
        _Filters.origin = this.props.tableNameKey;

        const query = queryString.parse(this.props.location.search);
        // Any link into the tab (filters or just targetQuery, which can hide the filter panel) is an
        // explicit request: defaults must neither be applied nor left over from an earlier visit.
        const isDeepLink = Object.keys(query).length > 0;
        const useDefaults = !!this.props.defaultFilters && isNewOrigin && !isDeepLink;
        if (useDefaults) {
            this.setDefaultFilters();
        } else if (this.props.defaultFilters && isDeepLink && !isNewOrigin) {
            this.props.clearFilters();
        }
        const isTargetQuery = !Object.keys(query).includes('targetQuery') || (Object.keys(query).includes('targetQuery') && query.targetQuery === this.props.tableNameKey)

        const parsedFilters: any = {};
        let shouldSubmit: boolean = false
        // tslint:disable-next-line: forin
        for (const param in query) {
            // targetQuery is routing metadata, not a search criterion
            if (param === 'targetQuery') {
                shouldSubmit = isTargetQuery
                continue;
            }
            const field = parseURLParamForFilters(param);
            const value: any = (param === 'VesselNames' || param === 'DocumentType') ? [query[param]] : (query[param] ? query[param] : '');
            this.props.setFilter(field, value);
            parsedFilters[field] = value;
            shouldSubmit = isTargetQuery
        }
        this.props.applyFilters();
        // same tab re-entered without a link: the grid starts empty, so search the retained filters again
        const isReturnVisit = !!this.props.defaultFilters && !isNewOrigin && !isDeepLink && hasFilterValues(this.props.currentFilters);
        if (useDefaults || isReturnVisit || (shouldSubmit && (!this.props.requireFilters || hasFilterValues(parsedFilters)))) {
            this.props.fetchFunction(1, this.props.pageSize);
        }
    }
    public componentDidUpdate(props: any) {
        if (props.tableNameKey !== this.props.tableNameKey) {
            this.props.setEmptyFilters(this.props.filters);
            this.props.clearFilters();
            _Filters.origin = this.props.tableNameKey;
        }
        // ||  this.props.filters !== props.filters
        if (this.props.genericFilter !== props.genericFilter) {
            if ((this.props.genericFilter || this.props.genericFilter === '') && this.myDom && this.myDom.current) {
                this.props.setFilter(this.myDom.current.querySelector('input').id, this.props.genericFilter)
                this.props.applyFilters();
            }
        }
        if (this.props.triggerClear && this.props.triggerClear !== props.triggerClear) {
            this.props.clearFilters()
        }
        if (this.props.triggerFilter && this.props.triggerFilter !== props.triggerFilter) {
            if (this.props.triggerFilter.DocumentType) {
                this.props.setFilter('DocumentType', this.props.triggerFilter.DocumentType);
            }
            this.props.applyFilters()
        } else if (this.props.triggerFilter !== props.triggerFilter) {
            this.props.applyFilters()
        }
        if(this.props.currentFilters !== props.currentFilters && this.props.watchChanges) {
            this.props.watchChanges(this.props.currentFilters);
        }
    }
    public listenToKeys = (event: KeyboardEvent) => {
        if(event.keyCode === 13 && event.code === 'Enter' && !this.missingRequiredFilters()){
            this.onApplyClick()
        }
    }
    public setDefaultFilters = () => {
        if (this.props.defaultFilters) {
            const defaults = this.props.defaultFilters();
            Object.keys(defaults).forEach((name) => this.props.setFilter(name, defaults[name]));
        }
    }
    public missingRequiredFilters = () => !!this.props.requireFilters && !hasFilterValues(this.props.currentFilters);
    public applyDocType = () => {
        if (this.props.triggerFilter && this.props.triggerFilter.DocumentType) {
            if (this.props.currentFilters && this.props.currentFilters.DocumentType) {
                this.props.setFilter('DocumentType', this.props.currentFilters.DocumentType);
            } else {
                this.props.setFilter('DocumentType', this.props.triggerFilter.DocumentType);
            }
        }
    }
    public render() {
        const rows = this.state.isExpanded ? this.renderRows(this.props.filters) : this.renderFirstRow(this.props.filters);
        return (
            <React.Fragment>
                {this.props.error && <p>{this.props.errorMessage}</p>}
                <HandleError
                    error={this.props.error}
                />
                {!this.props.withoutFilters && <div className="grid-wrapper">
                    <form className="filter-search-criteria">
                        <fieldset ref={this.myDom}>
                            <div className="filter-header">
                                Filters
                            </div>
                            <div className="filter-body">
                                {rows}
                            </div>
                        </fieldset>
                        <FilterFooter
                            disableExpand={this.props.filters.length>4? true: false}
                            disableSubmit={this.props.disableSubmit || this.missingRequiredFilters()}
                            onApplyClick={() => this.onApplyClick()}
                            onClearClick={() => this.onClearClick()}
                            isExpanded={this.state.isExpanded?this.state.isExpanded:false}
                            onToggleClick={() => this.expandFilters()}
                        />
                    </form>
                </div>}
            </React.Fragment>
        )
    }

    private injectStateControl = (fields: ReactNodeArray): ReactNodeArray => {
        return fields.map((field: any) => {
            const { name, type } = field.props;
            const onChange = (event: any) => {
                switch (type) {
                    case 'input': {
                        return this.props.setFilter(name, event.target.value);
                    }
                    case 'date': {
                        return this.props.setFilter(name, event);
                    }
                    case 'arrayOne': {
                        return this.props.setFilter(name, [event.target.value]);
                    }
                    case 'array': {
                        return this.props.setFilter(name, event);
                    }
                    case 'boolean': {
                        const returnBoolean = () => {
                            const e = event as any;
                            return e.target.value === 'true';
                        };
                        return this.props.setFilter(name, returnBoolean());
                    }
                    case 'number': {
                        if (event.target.value) {
                            return this.props.setFilter(name, event.target.value);
                        }
                        return this.props.setFilter(name, '');
                    } case 'check': {
                        if (event) {
                            return this.props.setFilter(name, event);
                        }
                        return this.props.setFilter(name, '');
                    } case 'dateFromTo': {
                        if (field.props.minValue || field.props.relatedField) {
                            return this.checkDateDependency(this.props, event, field)
                        }
                        return this.props.setFilter(name, event);
                    } case 'relationship': {
                        if (field.props.minValue || field.props.relatedField) {
                            return this.checkDependency(this.props, event.target.value, field)
                        }
                        return this.props.setFilter(name, event);
                    }
                    default: {
                        return this.props.setFilter(name, event.target.value);
                    }
                }
            };
            return (
                <field.type
                    {...field.props}
                    onChange={onChange}
                    value={this.props.currentFilters[name] || ''}
                    key={name}
                />
            );
        });
    };
    private checkDependency = (props: any, e: any, field: any): ReactNodeArray => {
        if (field.props.minValue && e && props.currentFilters[field.props.minValue] !== undefined) {
            const campareTo = props.currentFilters[field.props.minValue]
            if (campareTo) {
                field.props.setValidity(false);
            } else {
                field.props.setValidity(true);
            }
        } else if (field.props.relatedField && e && props.currentFilters[field.props.relatedField] !== undefined) {
            const compareTo = props.currentFilters[field.props.relatedField];
            if (compareTo) {
                field.props.setValidity(false);
            } else {
                field.props.setValidity(true);
            }
        }
        return props.setFilter(field.props.name, e);
    }
    private checkDateDependency = (props: any, e: any, field: any): ReactNodeArray => {
        if (field.props.minValue && e && props.currentFilters[field.props.minValue]) {
            const campareTo = moment.utc(props.currentFilters[field.props.minValue]).format('YYYY-MM-DD');
            if (campareTo && (moment.utc(e).format('YYYY-MM-DD') >= campareTo)) {
                field.props.setValidity(false);
            } else {
                field.props.setValidity(true);
            }
        } else if (field.props.relatedField && e && props.currentFilters[field.props.relatedField]) {
            const compareTo = moment.utc(props.currentFilters[field.props.relatedField]).format('YYYY-MM-DD');
            if (compareTo && (moment.utc(e).format('YYYY-MM-DD') <= compareTo)) {
                field.props.setValidity(false);
            } else {
                field.props.setValidity(true);
            }
        } else {
            field.props.setValidity(false);
        }
        return props.setFilter(field.props.name, e);
    }
    private renderRows = (fields: ReactNodeArray) => {
        const fieldsWithStateControl = this.injectStateControl(fields);
        const rowsNumber = Math.ceil(fields.length / 4);
        const rows = [];
        for (let n = 0; n < rowsNumber; n++) {
            const row = (
                <div className="grid-wrapper" key={n}>
                    {fieldsWithStateControl[n * 4]}
                    {fieldsWithStateControl[n * 4 + 1]}
                    {fieldsWithStateControl[n * 4 + 2]}
                    {fieldsWithStateControl[n * 4 + 3]}
                </div>
            );
            rows.push(row);
        }
        return rows;
    };

    private renderFirstRow = (fields: ReactNodeArray) => this.renderRows(fields.slice(0, 4));

    private expandFilters = (): void => this.setState((state: IFiltersState) => ({
        isExpanded: !state.isExpanded,
    }));

    private onApplyClick = () => {
        if (this.props.resetPaging && !this.state.onApplyClickReq) {
            this.props.resetPaging(1, this.props.pageSize)
            this.setState({
                onApplyClickReq: true
            })
            setTimeout(() => {
                this.onApplyClick()
            }, 500)
        } else {
            this.setState({
                onApplyClickReq: false
            })
            this.props.applyFilters();

            const filtersToUrl = {};
            // tslint:disable-next-line: forin
            for (const property in this.props.currentFilters) {
                const filterValue = this.props.currentFilters[property];
                if (Boolean(filterValue) && moment.isMoment(filterValue) && filterValue.isUTC()) {
                    // date pickers hold UTC moments; keep the exact instant (incl. end-of-day) across the URL round trip
                    filtersToUrl[property] = filterValue.toISOString();
                } else if (Boolean(filterValue) && moment.isMoment(filterValue)) {
                    filtersToUrl[property] = moment(filterValue).format('YYYY-MM-DDT00:00:00.000Z');
                } else if (Boolean(filterValue)) {
                    filtersToUrl[property] = filterValue;
                }
            }

            if (Object.keys(filtersToUrl).length) {
                this.props.history.push({
                    pathname: this.props.location.pathname,
                    search: queryString.stringify(filtersToUrl)
                })
            }

            this.props.fetchFunction(1, this.props.pageSize);
        }
    };

    private onClearClick = () => {
        if (this.props.resetErrors) {
            this.props.resetErrors();
        }
        this.props.clearFilters();

        if (this.props.defaultFilters) {
            // back to the default window and search it, exactly as if the user pressed Apply
            this.setDefaultFilters();
            this.onApplyClick();
            return;
        }

        if (this.props.location.search) {
            this.props.history.push(this.props.location.pathname);
        }

        setTimeout(() => {
            if (!this.missingRequiredFilters()) {
                this.props.fetchFunction(1, this.props.pageSize)
            }
        }, 200)
    };
}

const mapStateToProps = (state: IStore): IMapStateToProps => ({
    sort: {
        order: state.filters.order,
        column: state.filters.column,
    },
    pageSize: state.filters.pageSize,
    totalCount: state.filters.totalCount,
    pageNumber: state.filters.pageNumber,
    currentFilters: state.filters.filters,
    appliedFilters: state.filters.appliedFilters,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>): IDispatch => ({
    setEmptyFilters: (filters: ReactNodeArray) => dispatch(setEmptyFilters(filters)),
    setFilter: (name: string, value: string | boolean | any[] | number) => dispatch(setFilter(name, value)),
    applyFilters: () => dispatch(applyFiltersAction()),
    clearFilters: () => dispatch(clearFilters()),
});

const __Filters = connect(mapStateToProps, mapDispatchToProps)(_Filters);
export const Filters = withRouter(__Filters);